import VerofreshRecord from './VerofreshRecord'

/**
 * A single global feature-flag setting row ({ key, value }) delivered from the
 * `feature.*` namespace of the backend settings table via GET /v2/feature
 * (VF-4173). Only `feature.*` settings are ever exposed to the SPA — secrets
 * under other prefixes never cross to the browser.
 *
 * The three-tier cascade (global / customer / user) lives in featureModule,
 * which has the customer + user tiers available in the store. This record is
 * just the transport for the global tier.
 */
class FeatureRecord extends VerofreshRecord {
  static get endpoint () { return 'feature' }
}

export default FeatureRecord
